import '.di{font-size:1.125rem;}.ssr-plugin'
import '.f1{line-height:1.75rem;}.ssr-plugin'
import '.iu{text-decoration:none;}.ssr-plugin'
import '.dh{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="di f1"
    >
      {translations.privacySubtitle}{' '}
      <a className="iu dh"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="iu dh"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
